export { default } from "./MovimientosIngredientes";
